<template>
  <v-layout column>

    <h3>A CRIANÇA JÁ FREQUENTOU ESCOLA? DID YOUR CHILD ATTEND ANOTHER SCHOOL?</h3>

    <v-radio-group v-model="resource.form.attended_another_school" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <v-layout row wrap>
      <v-flex d-flex xs12 sm6 md6>
        <v-text-field outline :background-color="isFieldDisabled ? '#ccc' : ''" :disabled="isFieldDisabled"
          v-model="resource.form.school_name" :rules="resource.form.attended_another_school ? emptyRule : []"
          label="NOME DA ESCOLA / SCHOOL’S NAME" />
      </v-flex>

      <v-flex d-flex xs12 sm6 md6>
        <v-text-field outline :background-color="isFieldDisabled ? '#ccc' : ''" :disabled="isFieldDisabled"
          v-model="resource.form.time_frequented" :rules="resource.form.attended_another_school ? emptyRule : []"
          label="POR QUANTO TEMPO? / HOW LONG?" />
      </v-flex>
    </v-layout>

    <v-text-field outline :background-color="isFieldDisabled ? '#ccc' : ''" :disabled="isFieldDisabled"
      v-model="resource.form.reason_of_change" :rules="resource.form.attended_another_school ? emptyRule : []"
      label="RAZÃO DA MUDANÇA? / REASON FOR CHANGING?" />

    <v-layout row wrap>
      <v-flex d-flex xs12 sm6 md6>
        <v-text-field outline v-model="entry_date" :rules="[rules.date]" mask="##/##/####" return-masked-value
          placeholder="dd/mm/yyyy" label="DATA DE ENTRADA NA MAPLE BEAR JARDINS / ENTRY DATE AT MAPLE BEAR JARDINS?" />
      </v-flex>
      <v-flex d-flex xs12 sm6 md6>
        <v-text-field outline v-model="resource.form.entry_series" label="SÉRIE DE ENTRADA / ENTRY SERIES" />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { formatDateToPtBR, formatDateToDbFormat } from '@/helpers/formatDbDate'
import { date as datePattern } from '@/helpers/regex'

/**
 * @group Form
 * Componente de form para dados de Histórico Escolar do estudante
 */
export default {
  name: 'FormFamiliarHistory',

  inject: ['resource'],

  data: () => ({
    rules: {
      date: value => {
        if (!value) return true
        return datePattern.test(value) || 'Data inválida/Invalid date'
      }
    },
    emptyRule: [v => !!v || 'Campo obrigatório/Field is required']
  }),

  computed: {
    isFieldDisabled () {
      return this.resource.form.attended_another_school === null || !this.resource.form.attended_another_school
    },

    resource () {
      return this.resource
    },

    entry_date: {
      get () {
        return formatDateToPtBR(this.resource.form.entry_date)
      },

      set (newValue) {
        this.resource.form.entry_date = formatDateToDbFormat(newValue)
      }
    }
  },

  methods: {
    /**
     * @vuese
     * Método para validação da form
     */
    validateForm () {
      return this.$refs.form.validate()
    }
  }
}
</script>
